module.exports = __webpack_public_path__ + "static/img/sms.af33bcd.svg";